import React from 'react'
import { useSelector } from 'react-redux'

import AppForm from 'components/Form/AppForm/AppForm'
import { extendedInfoForm } from 'FormDefinitions/ExtendedInfoForm/ExtendedInfoFormDefinition'
import useAppFormLogic from 'components/Form/AppForm/hooks/useAppFormLogic'
import { AppState } from 'store'
import { ExtendedInfoFieldsNames, extendedInfoFields } from 'FormDefinitions/ExtendedInfoForm/ExtendedInfoFields'
import { AdditionalApplicationDataProps } from 'components/Form/AppForm/AppFormProps'


/**
 * Ostatnia strona formularza zbierająca informacje o dochodach oraz dowodzie osobistym
 */
const ExtendedInfoForm = (): JSX.Element => {
   const formState = useSelector((state: AppState) => state.formState)
   const consentsState = useSelector((state: AppState) => state.consentsState.appConsents)
   const applicationState = useSelector((state: AppState) => state.applicationState)
   const minimalLoanAmountToDisplayAdditionalFields = useSelector((state: AppState) => state.globalConfigurationState.globalConfig.minimalLoanAmountToDisplayAdditionalFields)
   const extendedInfoLimitedFieldsNames = [ExtendedInfoFieldsNames.Pesel, ExtendedInfoFieldsNames.PersonalId, ExtendedInfoFieldsNames.PersonalIdRelease]


   const additionalApplicationData: AdditionalApplicationDataProps = {
      minimalLoanAmountToDisplayAdditionalFields,
      amountToPay: applicationState.amountToPay,
      billingCompany: applicationState.billingCompany
   }

   const { handleExtendedInfoFormSubmitButtonClick, setCurrentFormFields } = useAppFormLogic({ form: extendedInfoForm })
   

   return ( 
      <AppForm 
         form={setCurrentFormFields(extendedInfoForm, extendedInfoLimitedFieldsNames, extendedInfoFields, additionalApplicationData)} 
         handleSubmitButtonClick={(e: React.SyntheticEvent) => handleExtendedInfoFormSubmitButtonClick(e, formState, consentsState, additionalApplicationData)} 
      />
   )
}

export default ExtendedInfoForm